import React, { useMemo } from 'react'
import { PerformanceMonitoringData } from '../GeneralInformation/typesExtendedReport'

export const usePerformanceMappedData = (data: PerformanceMonitoringData | null | undefined) => {

    return useMemo(() => {
        if (!data) return null

        return {
            PmrDivisions: data.pmrDivision,
            EvolutionPM: data.evolutionLastYear,
            More3MM: data.pmrStateDistributionLonIgrMore3MM,
            LessThan3MM: data.pmrStateDistributionTcpIgrLessThan3MM
        }

    }, [data])
}
